import { toast } from "vue3-toastify";
export type ArticleTheme = {
  _id: string;
  name: string;
};
export const useArticleThemeStore = defineStore("articleTheme", () => {
  const themes = ref<ArticleTheme[]>([]);
  const selectedTheme = ref<ArticleTheme | null | "no-theme">(null);
  const $privateApi: any = useNuxtApp().$privateApi;

  const getThemes = async () => {
    try {
      const response = await $privateApi.get("/api/bo/article/series");
      themes.value = response.data;
    } catch (error) {
      toast.error("Une erreur est survenue lors de la récupération des thèmes");
    }
  };

  const getThemesByCategory = async (categoryId: string) => {
    try {
      const response = await $privateApi.get(
        `/api/bo/article/series/category/${categoryId}`
      );
      themes.value = response.data;
      // Reset selected theme when category changes
      selectedTheme.value = null;
    } catch (error) {
      toast.error("Une erreur est survenue lors de la récupération des thèmes");
    }
  };

  const setSelectedTheme = (theme: ArticleTheme | null | "no-theme") => {
    selectedTheme.value = theme;
  };

  return {
    themes,
    getThemes,
    selectedTheme,
    setSelectedTheme,
    getThemesByCategory,
  };
});
